import { mapToObjArr } from 'app/admin/common/util/CommonUtil';
import TaskManagerEditDto from './TaskManagerEditDto';

export class ModelValidationTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number} */
        this.measurement = null;

        /** @type {number} */
        this.aspect = null;

        /** @type {number} */
        this.modelValidation = null;

        /** @type {number} */
        this.optimizationPipelineLog = null;

        /** @type {number} */
        this.modelValidationLog = null;

        /** @type {Date} */
        this.ts = null;

        /** @type {string} */
        this.tolerance = null;
    }

    /**
     * @typedef {Object} _ModelValidationTaskEditDto Props
     * @property {number} measurement
     * @property {number} aspect
     * @property {number} modelValidation
     * @property {number} optimizationPipelineLog
     * @property {number} modelValidationLog
     * @property {Date} ts
     * @property {string} tolerance
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _ModelValidationTaskEditDto Props} ModelValidationTaskEditDto Props
     */
    /**
     *
     * @param {ModelValidationTaskEditDto Props} props
     * @returns {ModelValidationTaskEditDto }
     */
    setup(props) {
        super.setup(props);

        this.measurement = props.measurement;
        this.aspect = props.aspect;
        this.modelValidation = props.modelValidation;
        this.optimizationPipelineLog = props.optimizationPipelineLog;
        this.modelValidationLog = props.modelValidationLog;
        this.ts = props.ts;
        this.tolerance = props.tolerance ? mapToObjArr(props.tolerance, 'name', 'tolerance') : null;

        return this;
    }
}

export default ModelValidationTaskEditDto;